export const generateActivityFilters = (filters = {}, transform, rootLevelFilters) => {
  return Object.entries(filters).reduce((acc, [key, filter]) => {
    const entry = transform ? transform(key, filter) : {
      [key]: filter
    };
    return rootLevelFilters !== null && rootLevelFilters !== void 0 && rootLevelFilters.includes(key) ? {
      ...acc,
      ...entry
    } : {
      ...acc,
      arguments: {
        ...acc.arguments,
        ...entry
      }
    };
  }, {
    type: 'AND',
    arguments: {}
  });
};